module.exports = __webpack_public_path__ + "img/_SDI9254.32a47acf.jpg";